import * as PIXI from "pixi.js";
import Game from "../../../Game";
import Layers from "../../../layers/Layers";
import CustomCursorDrawingFactory from "./CustomCursorDrawingFactory";
import { EnumRootEventBus, rootEventBus } from "../../../managers/RootEventBus";
import { Coord } from "../../../types/Interface";
import { cursorEventBus, EnumCursorEventBus } from "./CustomCursorEventBus";
import getCleanCoord from "../../../utils/coord/getCleanCoord";


export default class CustomCursor extends PIXI.Graphics {
  private Game = Game.getInstance();
  private cursorType!: CustomCursorType;
  private interactLayerCursor = CustomCursorType.default;
  private pencilColor: number = 0x000000;

  constructor() {
    super();

    this.setLayer(true);
    this.eventMode = "none";
    this.setVisibilityForDevice();
    rootEventBus.on(EnumRootEventBus.setPointerMove, (coord: Coord) => this.followPointer(coord));
    cursorEventBus.on(EnumCursorEventBus.setInteractLayerCursor, (c: CustomCursorType) => this.setInteractLayerCursor(c));
    cursorEventBus.on(EnumCursorEventBus.setCursor, (type: CustomCursorType, coord: Coord, isMutable: boolean) => this.setCustomCursor(type, coord, isMutable))
    cursorEventBus.on(EnumCursorEventBus.setRotation, (rotation: number) => this.setRotation(rotation));
    cursorEventBus.on(EnumCursorEventBus.setColor, (color: number) => this.setColor(color))
  }

  setLayer(isGame: boolean) {
    this.parent?.removeChild(this);
    if (isGame) { return this.Game.stage.addChild(this) }
    const layers = Layers.getInstance();
    layers.UITop.addChild(this);
  }
  private setRotation = (rot: number) => this.rotation = rot ? rot : 0;
  private setColor = (color: number) => this.pencilColor = color;
  private setInteractLayerCursor = (c: CustomCursorType) => this.interactLayerCursor !== c ? this.interactLayerCursor = c : "";
  private followPointer = (coord: Coord) => this.visible && this.position.copyFrom(getCleanCoord(coord));
  private setVisibilityForDevice() {
    const isCoarsePointer = window.matchMedia("(pointer: coarse)").matches;
    const isSmallScreen = window.innerWidth < 1024;

    const isDesktop = !isCoarsePointer && !isSmallScreen;
    this.visible = isDesktop;
  }
  private setCustomCursor(_type: CustomCursorType, coord: Coord, isMutable: boolean) {
    const type = isMutable ? this.interactLayerCursor : _type;

    this.cursorType = type;
    if (this.interactLayerCursor !== CustomCursorType.pencil && this.cursorType !== CustomCursorType.pencil) {
      this.rotation = 0;
    }

    switch (type) {
      case CustomCursorType.default:
        CustomCursorDrawingFactory.drawDefaultIcon(this);
        break;
      case CustomCursorType.pointer:
        CustomCursorDrawingFactory.drawPointerIcon(this);
        break;
      case CustomCursorType.grab:
        CustomCursorDrawingFactory.drawGrabIcon(this);
        break;
      case CustomCursorType.pencil:
        CustomCursorDrawingFactory.drawPencilIcon(this, this.pencilColor);
        break;
      case CustomCursorType.rotate:
        CustomCursorDrawingFactory.drawRotateIcon(this);
        break;
      case CustomCursorType.target:
        CustomCursorDrawingFactory.drawTargetIcon(this);
        break;
      default:
        this.clear();
        break;
    }
    coord && this.followPointer(coord)
  }
}


export enum CustomCursorType {
  default = "DEFAULT",
  pointer = "POINTER",
  grab = "GRAB",
  rotate = "ROTATE",
  pencil = "PENCIL",
  target = "TARGET",
  empty = "EMPTY"
}